import React, { useState } from 'react';
import {
  Breadcrumbs, Link, Stack, Typography, Popover, List, ListItem, ListItemButton, ListItemText
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from "react-router-dom";
import breadcrumbsData from '../../../Constants/BreadCrumbsHierarchy';
import { styled } from "@mui/material/styles";

const StyledListItem = styled(ListItem)(({ theme, noHover }) => ({
  ...(noHover && {
    pointerEvents: "none",
    "&:hover": {
      backgroundColor: "transparent",
    },
  }),
}));

const BreadcrumbLink = (props) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState(null);

  const handlePopoverOpen = (event, title) => {
    const breadcrumb = (breadcrumbsData?.find(item => item.title === title));
    setBreadcrumb(breadcrumb);
    if (breadcrumb?.children && breadcrumb?.children?.length > 1) {
      setAnchorEl(event.currentTarget);
    }
    else {
      title === 'Home' ? window.location.href = breadcrumb?.path : navigate(breadcrumb?.path);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  // Handle child selection
  const handleChildClick = (menu, child) => {
    setAnchorEl(null); // Close the popover
    navigate(child?.path, { state: { menu, label: child?.title } })
  };

  const handleHoverValue = (childTitle) => {
    const containsTitle = props?.breadcrumbArray?.some(item => item === childTitle 
      || childTitle === 'Warehouse Capacity' || childTitle === 'Fiscal Calendar' || childTitle === 'Documents' 
      || childTitle === 'Items' || childTitle === 'Sites' || childTitle === 'Nodes' || childTitle === 'Sourcing Lanes'
      || childTitle === 'Participants' || childTitle === 'Batches');
    return containsTitle;
  }

  return (
    <Stack spacing={2} className={`${props.className}`}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ '& .MuiBreadcrumbs-separator': { m: '0px' } }}
      >
        {props?.breadcrumbArray?.map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              {(idx !== props?.breadcrumbArray?.length - 1) ? <Link underline="hover" key={item} color="inherit" style={{ cursor: 'pointer' }}
                onClick={(e) => handlePopoverOpen(e, item)}>
                <Typography key={item} color="text.primary" fontSize={13} fontWeight="inherit">
                  {item}
                </Typography>
              </Link> : <Typography key={item} color="text.primary" fontSize={13} fontWeight={"bolder"}>
                {item} {props?.count !== undefined && ('(' + props?.count + ')')}
              </Typography>}

              <Popover disablePadding
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                disableRestoreFocus
              >
                <List sx={{ p: 0.5, backgroundColor: '#ffffff', color: '#8a8b8cff', borderRadius: '5px' }}>
                  {breadcrumb?.children?.map((child) => (
                    <StyledListItem disablePadding noHover={handleHoverValue(child.title) ? true : false}>
                      {/* </StyledListItem><StyledListItem disablePadding noHover={true}> */}
                      <ListItem key={child.path} sx={{
                        px: 1, py: 0.6, height: '32px',
                        '&:hover': {
                          backgroundColor: 'rgba(96, 96, 96, 0.5)'
                        },
                      }}>
                        <ListItemButton sx={{ p: 0 }}
                          onClick={() => handleChildClick(breadcrumb.title, child)}>
                          <ListItemText sx={{ m: 0 }} primary={<Typography key={child.title} color="text.primary" fontSize={13} >
                            {child.title}
                          </Typography>} />
                        </ListItemButton>
                      </ListItem>
                    </StyledListItem>
                  ))}
                </List>
              </Popover>
            </React.Fragment>
          )
        })}
      </Breadcrumbs>
    </Stack>
  );
}

export default BreadcrumbLink;